import { MitarbeiterDepartments, ProfitCenterAbteilung } from '@/types/service-response'

export class EmployeeDepartment {
  public constructor (
    readonly Label: string,
    readonly Mitarbeiter: number| null,
    readonly Profitcenter: number,
    readonly ProfitcenterBezeichnung: string | null,
    readonly Abteilung: number,
    readonly AbteilungBezeichnung: string | null
  ) {}

  static createFromResponse (responseData: MitarbeiterDepartments[]): Array<EmployeeDepartment> {
    let result: Array<EmployeeDepartment> = []
    if (responseData) {
      result = responseData.map((item: MitarbeiterDepartments) => {
        return new EmployeeDepartment(
          `${item.ProfitcenterBezeichnung ? item.ProfitcenterBezeichnung : ''} - ${item.AbteilungBezeichnung ? item.AbteilungBezeichnung : ''}`,
          item.Mitarbeiter,
          item.Profitcenter,
          item.ProfitcenterBezeichnung,
          item.Abteilung,
          item.AbteilungBezeichnung
        )
      })
    }
    return result
  }

  static createFromDepartmentResponse (responseData: ProfitCenterAbteilung[]): Array<EmployeeDepartment> {
    let result: Array<EmployeeDepartment> = []
    if (responseData) {
      result = responseData.map((item: ProfitCenterAbteilung) => {
        return new EmployeeDepartment(
          `${item.ProfitcenterBezeichnung ? item.ProfitcenterBezeichnung : ''} - ${item.AbteilungBezeichnung ? item.AbteilungBezeichnung : ''}`,
          null,
          item.ProfitCenter,
          item.ProfitcenterBezeichnung,
          item.Abteilung,
          item.AbteilungBezeichnung
        )
      })
    }
    return result
  }
}
